/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class RoleRepo {

    static $resource = 'roles';
        
    constructor($auth){
        $http = new Http($auth);        
    }            
    
    all(){            
        return $http.get(RoleRepo.$resource).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }
   
    
   
}


// WEBPACK FOOTER //
// ./src/repos/RoleRepo.js